import { render, staticRenderFns } from "./DashProjectView.vue?vue&type=template&id=71096494&scoped=true&"
import script from "./DashProjectView.vue?vue&type=script&lang=js&"
export * from "./DashProjectView.vue?vue&type=script&lang=js&"
import style0 from "./DashProjectView.vue?vue&type=style&index=0&id=71096494&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71096494",
  null
  
)

export default component.exports